<script>
  import Emitter from 'theme/mixins/emitter';

  export default {
    name: 'ZkCheckboxGroup',

    componentName: 'ZkCheckboxGroup',

    mixins: [Emitter],

    props: {
      value: {}
    },

    watch: {
      value(value) {
        this.$emit('change', value);
        this.dispatch('form-item', 'zk.form.change', [value]);
      }
    }
  };
</script>

<template>
  <div class="zk-checkbox-group">
    <slot></slot>
  </div>
</template>



// WEBPACK FOOTER //
// checkbox-group.vue?ad1991e4